import { useOpenRequestStatus } from '@hooks/Services';
import { Error, Loading } from '@organisms/Feedbacks';
import { WarningMessageForm } from '@organisms/GenesisEs/Forms';
import React, { useState } from 'react';
import { useParams } from 'react-router-dom';
import styled from 'styled-components';
import { dateFormat } from '../Utils';

const timestamp = new Date().getTime();

const DetailTransmissionResult = () => {
    const id = useParams().id;
    const [updateTime, setUpdateTime] = useState(timestamp);
    const listData = useOpenRequestStatus.useAllListData(id, updateTime);
    const { data, error, loading } = listData;

    return (
        <WrapperWithStyled className='detailTableWrapper'>
            {loading && <Loading />}
            {error && <Error />}
            {data &&
                <>
                <table className='table table-bordered table-warning'>
                    <tbody>
                        <tr>
                            <th className='cell-20per'>接続供給開始日</th>
                            <td>{dateFormat(data.setsuzokuKyokyuKaishiYmd)}</td>
                        </tr>
                        <tr>
                            <th className='cell-20per'>廃止措置方法</th>
                            <td>{data.haishiSochiHohoMeisho}</td>
                        </tr>
                        <tr>
                            <th>ご連絡事項</th>
                            <td>{data.renrakuJiko}</td>
                        </tr>
                    </tbody>
                </table>

                <SubTitileWithStyled>受付メッセージ</SubTitileWithStyled>
                <table className='table table-bordered table-warning'>
                    <thead>
                        <tr>
                            <th className='cell-20per'>メッセージコード</th>
                            <th className='cell-30per'>メッセージ</th>
                            <th className='cell-10per'>対応状況</th>
                            <th className='cell-15per'>対応日時</th>
                            <th className='cell-15per'>対応者</th>
                            <th className='cell-10per'></th>
                        </tr>
                    </thead>
                    <tbody>
                        {data.uketsukeMessages?.uketsukeMessage?.map((uketsukeMessage: any, index: number) => {
                            return (
                                <tr key={index}>
                                    <td>{uketsukeMessage.uketsukeMessageKbn}</td>
                                    <td>{uketsukeMessage.uketsukeMessageKbnMeisho}</td>
                                    <td>{uketsukeMessage.uketsukeMessageStatusKbnName}</td>
                                    <td>{uketsukeMessage.updateDate}</td>
                                    <td>{uketsukeMessage.updateUser}</td>
                                    <ButtonWrapperWithStyled>
                                        {uketsukeMessage.uketsukeMessageStatusKbn === '0' ?
                                            <WarningMessageForm
                                                memoId={uketsukeMessage.id}
                                                afterSbumit={() => { setUpdateTime(new Date().getTime()) }}
                                            />
                                        :
                                            <></>
                                        }
                                    </ButtonWrapperWithStyled>
                                </tr>
                            );
                        })}
                    </tbody>
                </table>
                </>
            }
        </WrapperWithStyled>
    );
};

const WrapperWithStyled = styled.div`
    & td {
        background-color: white;
    }
`
const SubTitileWithStyled = styled.h3`
    margin: 20px 0 5px 5px;
    font-size: 16px;
    font-weight: bold;
`
const ButtonWrapperWithStyled = styled.td`
    padding: 0.2rem !important;
    text-align: center;
    & button {
        color: white;
        font-size: 12px;
        white-space: 
        padding: 0.1rem 0.3rem;
        &:hover {
            color: white;
        }
    }
`
export default DetailTransmissionResult;